const PRODUCT = [
  {
    id: 1,
    productName: "IPhone",
    price: 999.0,
    productImage:
      "https://www.91-img.com/gallery_images_uploads/3/d/3df5ca6a9b470f715b085991144a5b76e70da975.JPG?tr=h-550,w-0,c-at_max",
  },
  {
    id: 2,
    productName: "Macbook Pro 2022 (M1)",
    price: 1999.0,
    productImage:
      "https://www.apple.com/newsroom/images/product/mac/standard/Apple_MacBook-Pro_14-16-inch_10182021_big.jpg.large.jpg",
  },
  {
    id: 3,
    productName: "Cannon M50 Camera",
    price: 699.0,
    productImage:
      "http://i1.adis.ws/i/canon/eos-m50-bk-ef-m15-45-stm-frt-2_b6ff8463fb194bfd9631178f76e73f9a",
  },
  {
    id: 4,
    productName: "WLS Van Gogh Denim Jacket",
    price: 228.0,
    productImage:
      "https://media.istockphoto.com/id/1352728757/photo/jean-jacket-isolated-on-white-front-and-back-views-ready-for-clipping-path.jpg?s=612x612&w=0&k=20&c=iwmb9OjT2bTlphopO__T7m-n6sFEMiJV6TKVO8-Xyk0=",
  },
  {
    id: 5,
    productName: "sadhasd Van Gogh Denim Jacket",
    price: 228.0,
    productImage:
      "https://media.istockphoto.com/id/1352728757/photo/jean-jacket-isolated-on-white-front-and-back-views-ready-for-clipping-path.jpg?s=612x612&w=0&k=20&c=iwmb9OjT2bTlphopO__T7m-n6sFEMiJV6TKVO8-Xyk0=",
  },
];

export default PRODUCT;
